<template>
    <Transition name="slide-fade">
        <div v-if='isVisible' class="cookie-banner">
            <div class="cookie-header">{{LOCAL('cookie_accept_title')}}</div>
            <div class="cookie-content">
                <div class="cookie-context">{{LOCAL('cookie_accept_context')}}</div>
                <div class="cookie-btn-group">
                    <button class="cookie-reject-btn" @click="rejectCookies()">{{LOCAL('cookie_reject_btn')}}</button>
                    <button class="cookie-accept-btn" @click="acceptCookies()">{{LOCAL('cookie_accept_btn')}}</button>
                </div>
            </div>
            
        </div>
    </Transition>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import { LOCAL, getLocalLangCode } from '@/assets/lang';
  
  const isVisible = ref(false)
  
  function acceptCookies() {
    localStorage.setItem('cookies_accepted', new Date().toISOString())
    isVisible.value = false
  }

  const rejectCookies = () => {
    isVisible.value = false
  }
  
  onMounted(() => {
    const acceptDate = localStorage.getItem('cookies_accepted')
    
    if (!acceptDate) {
      isVisible.value = true
    }
  })
  </script>

<style scoped lang="less">
    @import "index.less";
</style>